import React, { memo } from 'react';
import TooltipV2 from '@/components/TooltipV2';
import Icon, { IconName } from '@/components/atoms/Icon';
import Button from '@/components/atoms/Button/Button';
import { classnames } from '@/libs/utils';

function PlayerTimelineButton({
  tooltipTitle,
  buttonId,
  onClick,
  iconName,
  isDisabled,
  iconSize = 15,
  isLoading = false,
  buttonClassName = '',
  omitStoppingPropagation = false
}: {
  tooltipTitle: string;
  buttonId: string;
  onClick: (e: React.MouseEvent<Element, MouseEvent>) => void;
  iconName: IconName;
  isDisabled?: boolean;
  buttonClassName?: string;
  iconSize?: number;
  isLoading?: boolean;
  onMouseDown?: (e: React.MouseEvent<Element, MouseEvent>) => void;
  omitStoppingPropagation?: boolean;
}) {
  return (
    <TooltipV2
      tooltipId={buttonId}
      tooltipContent={tooltipTitle}
      noArrow
      place="top"
      positionStrategy="fixed"
      className="z-10"
      tooltipElement={
        <Button
          className={classnames('flex size-[42px] items-center justify-center !p-0', buttonClassName)}
          variation="checkbox"
          trackingId={buttonId}
          onClick={onClick}
          buttonSize="base"
          disabled={isDisabled}
          onMouseDown={e => {
            if (omitStoppingPropagation) {
              return;
            }
            e.stopPropagation();
          }}
        >
          {isLoading ? (
            <Icon name="IconLoader2" className="animate-spin" size={iconSize} stroke={2.5} />
          ) : (
            <Icon name={iconName} size={iconSize} stroke={2.5} />
          )}
        </Button>
      }
    />
  );
}

export default memo(PlayerTimelineButton);
